import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@material-ui/core';

class NumberInput extends Component {
  render() {
    const { className, name, onChange, tabIndex, value, disabled, min, max } = this.props;

    return (
      <TextField
        className={className}
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        type="number"
        InputProps={{
          disableUnderline: true,
          inputProps: { min, max, className: 'centerText', tabIndex }
        }}
        disabled={disabled}
      />
    );
  }
}

NumberInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
};

NumberInput.defaultProps = {
  className: undefined,
  disabled: false,
  tabIndex: 0,
  min: 0,
  max: null,
};

export default NumberInput;
